module.exports = __webpack_public_path__ + "851e5eb4eb749e5d0379cb6c03115cfd.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/jam-pad-empty.png
// module id = 310
// module chunks = 0